// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--1KF","actuator":"FavoriteIcon__actuator--30J","icon":"FavoriteIcon__icon--23Z","featured":"FavoriteIcon__featured--2ed","on":"FavoriteIcon__on--6Pw"};